export const SPARKS = {
  orange: {
    borderTop: "border-t-[3px] border-t-spark-orange",
    ring: "ring-spark-orange/25",
    ringActive: "ring-spark-orange/50",
    bg: "bg-spark-orange",
  },
  purple: {
    borderTop: "border-t-[3px] border-t-spark-purple",
    ring: "ring-spark-purple/25",
    ringActive: "ring-spark-purple/50",
    bg: "bg-spark-purple",
  },
  yellow: {
    borderTop: "border-t-[3px] border-t-spark-yellow",
    ring: "ring-spark-yellow/50",
    ringActive: "ring-spark-yellow/75",
    bg: "bg-spark-yellow",
  },
} as const

export type SparkColour = keyof typeof SPARKS
